import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
import { dispatch, store } from 'store';

import { CompanyModel } from 'types/company/company';
import { fetcher } from 'utils/axios';

const initialState: CompanyModel | null = null;

const companySlice = createSlice({
  name: 'company',
  initialState: initialState as CompanyModel | null,
  reducers: {
    setCompanyData(state, action: PayloadAction<CompanyModel>) {
      return action.payload;
    },
    updateCompanyData: (state, action: PayloadAction<Partial<CompanyModel>>) => {
      if (state) {
        Object.assign(state, action.payload);
      }
    },
    updateCompanyDataWithParams(state, action: PayloadAction<Partial<CompanyModel>>) {
      if (state) {
        const params = action.payload;
        if (params) {
          Object.assign(state, params);
        }
      }
    },
    resetCompanyData(state) {
      return initialState;
    },
  },
});

export default companySlice.reducer;
export const { setCompanyData, updateCompanyData, updateCompanyDataWithParams, resetCompanyData } =
  companySlice.actions;

export async function getCompanyData() {
  try {
    const data = await fetcher('get', '/api/services/GetCompanyDetails', 'history');
    if (data) {
      dispatch(setCompanyData(data));
    }
  } catch (error) {
    console.warn('getCompanyData err: ', error);
  }
}
export async function fetchUpdateCompanyData(params: Partial<CompanyModel>, sendNotification: boolean) {
  try {
    const currentCompanyData = store.getState().company;
    if (!currentCompanyData) {
      console.warn('fetchUpdateCompanyData: No company data yet');
      return;
    }

    const updatedCompanyData = { ...currentCompanyData, ...params };

    const data = await fetcher(
      'post',
      ['/api/services/SetCompanyConfig', { data: updatedCompanyData }],
      'history',
    );
    if (data) {
      dispatch(updateCompanyData(params));
    }
    if (sendNotification) {
      //TODO Localization
      enqueueSnackbar(data ? 'Success' : 'Error', {
        variant: data ? 'success' : 'error',
      });
    }
  } catch (error) {
    console.warn('fetchUpdateCompanyData err: ', error);
    //TODO Localization
    if (sendNotification)
      enqueueSnackbar('Error', {
        variant: 'error',
      });
  }
}
